<!--
 * @Description: txt的导出
 * @Author: gao shuai
 * @Date: 2020-06-13 10:40:32
 * @LastEditTime: 2020-09-01 16:12:12
 * @LastEditors: gao shuai
-->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>数据导出</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>时间：</span>
          <!-- <el-date-picker style="width:338px;" v-model="ordertime" size="small" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker> -->
          <el-date-picker style="width:190px;" v-model="ordertime1" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker> <span style="font-size:14px;">至 </span>
          <el-date-picker style="width:190px;" v-model="ordertime2" size="small" default-time="23:59:59" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
          </el-date-picker>
        </li>
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="accountID" @input="accountID=intNumber(accountID)" placeholder="请输入商户ID"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>充值金额：</span>
          <span class="txtbox">
            <el-input style="width:100px;" size="small" v-model="ontherecharge" @input="ontherecharge=intNumber(ontherecharge)" placeholder="请输入内容"></el-input> --
            <el-input style="width:100px;" size="small" v-model="undertherecharge" @input="undertherecharge=intNumber(undertherecharge)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>导出Excel：</span>
          <span class="txtbox">
            <el-select style="width:150px;" v-model="derive" clearable size="small" placeholder="请选择">
              <el-option v-for="(item,i) in derivedrow" :key="'derive'+i" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="exportExcel">导出</el-button>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { url } from '../../assets/js/version';
export default {
  data() {
    return {
      ordertime1: this.getCerentTime(true), // 订单时间
      ordertime2: this.getCerentTime(false), // 订单时间
      accountID: '', // 商户id
      ontherecharge: '', // 充值金额上
      undertherecharge: '', // 充值金额下
      derive: '', // 导出
      derivedrow: [
        { text: '玩家QQ', value: 1 },
        { text: '玩家手机', value: 2 },
        { text: '玩家QQ和手机', value: 3 }
      ] // 导出下拉
    };
  },
  methods: {
    // 导出TXT下拉
    exportExcel(value) {
      if (this.derive === '') {
        this.$messageError('请选择导出格式！');
        return;
      }
      /* eslint-disable */
      let adressUrl =
        url +
        '/api/Download/OutputTenantOrderAsync?StartTime=' +
        (this.ordertime1 ? this.ordertime1 : '') +
        '&EndTime=' +
        (this.ordertime2 ? this.ordertime2 : '') +
        '&AmountMin=' +
        (this.ontherecharge === '' ? '' : parseFloat(this.ontherecharge)) +
        '&MerchantId=' +
        (this.accountID === '' ? 0 : this.accountID) +
        '&AmountMax=' +
        (this.undertherecharge === ''
          ? ''
          : parseFloat(this.undertherecharge)) +
        '&exportStyleEnum=' +
        this.derive;
      /* eslint-enable */
      // 创建隐藏的可下载链接
      let eleLink = document.createElement('a');
      eleLink.style.display = 'none';
      // 字符内容转变成blob地址
      eleLink.href = adressUrl;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
</style>
